export default __webpack_public_path__ + "static/media/AcornMallFastFood_17.f06dca42.png";